const typeDisplayOptions = [
  { value: 'home', label: 'My Dashboard' },
  { value: 'rsv', label: 'RSV Incidence' },
  { value: 'flu', label: 'Flu Incidence' },
  { value: 'uti', label: 'UTI Dashboard' },
  { value: 'covid', label: 'COVID 19 Incidence' },
  { value: 'meningitis', label: 'Meningitis' },    
  { value: 'allergies', label: 'Allergies Incidence' },
  { value: 'vulnerability', label: 'Vulnerability Incidence' }  
  //  { value: 'vulnerability', label: 'Vulnerability' }
  // { value: 'birth', label: 'Births & Trends' },
  // { value: 'allergies', label: 'Allergies' },
  // { value: 'respiratory', label: 'Respiratory' },
]
export default typeDisplayOptions
